import { configureStore } from '@reduxjs/toolkit';
import * as concerns from './concerns';
import { initialState } from './concerns/actions';
import * as cache from './cache';
import { obj } from '$utils';

export const createStore = () =>
    configureStore({
        reducer: concerns,
        preloadedState: cache.get(),
    });

export const store = createStore();

store.subscribe(() => {
    const state = store.getState();

    cache.put({
        auth: state.auth,
        features: state.features,
        actions: {
            ...initialState,
            ...obj.pick(state.actions, ['sort', 'filters']),
        },
    });
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
